import { Component, inject, input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { EResultAggregation } from 'scw-digital-boards-widgets';
import { IDropdownOption, MatDropdown } from '../../../../../shared/components/mat-dropdown/mat-dropdown.component';
import { IDropdownSettings } from '../../../../../shared/components/mat-dropdown/scw-mat-dropdown.interface';

@Component({
  imports: [MatDropdown],
  selector: 'result-aggregation-dropdown',
  styleUrl: './result-aggregation-dropdown.component.scss',
  templateUrl: './result-aggregation-dropdown.component.html',
})
export class ResultAggregationDropdownComponent {
  public readonly translate = inject(TranslateService);

  public readonly formControl = input.required<FormControl<IDropdownOption<EResultAggregation>[]>>();
  public readonly isFormSubmitted = input.required<boolean>();

  public readonly dropdownSettings: IDropdownSettings = {
    enableSearchFilter: false,
    hasDelayedDefaultValue: true,
    isClientSide: true,
    repositionDropdownList: true,
    singleSelection: true,
    text: this.translate.instant('page.widgetContent.addEditDialog.resultAggregationDropdown.label'),
  };

  public readonly dropdownOptions = Object.values(EResultAggregation).map((name) => ({
    id: name,
    name: this.translate.instant(`page.widgetContent.addEditDialog.resultAggregationDropdown.options.${name}`),
  }));
}
